import useSWR from 'swr';
import workSessionService from '../services/workSessionService';

export default function useActiveWorkSessions() {
  const { data, isLoading, mutate } = useSWR(
    'work-sessions/active',
    () => workSessionService.getActiveSessions(),
    { refreshInterval: 60000 }
  );

  return {
    sessions: data || [],
    isLoading,
    mutate
  };
}
